import { Link } from "react-router-dom";
import { SiteFooter } from "@/components/SiteFooter";

export const AuthLayout = ({ children, blurb = "Staff sign-in for registration, payments, gate check-in, badges and CPD certificates." }) => (
  <div>
    <div className="min-h-screen grid lg:grid-cols-[1.1fr_1fr] bg-white">
      <div className="relative hidden lg:flex flex-col justify-between bg-[#111] text-white p-12 overflow-hidden">
        <div className="absolute -right-40 -top-40 w-[520px] h-[520px] rounded-full border-[48px] border-[#E60000]/90" />
        <Link to="/" title="Open homepage" className="relative flex items-center gap-3 w-fit hover:opacity-80 transition-opacity" data-testid="login-brand-home-link">
          <img src="/images/gamls-logo.png" alt="GAMLS" className="w-14 h-14 bg-white rounded-full p-0.5" />
          <div className="font-heading font-extrabold text-xl">GAMLS <span className="text-[#E60000]">EventHub</span></div>
        </Link>
        <div className="relative max-w-lg fade-up">
          <div className="text-[11px] font-bold uppercase tracking-[0.24em] text-[#FF4D4D]">Ghana Association of Medical Laboratory Scientists</div>
          <h1 className="font-heading text-5xl font-extrabold tracking-tight mt-4 leading-[1.05]">Events, payments & CPD — one precise platform.</h1>
          <p className="text-white/60 mt-5">{blurb}</p>
        </div>
        <div aria-hidden />
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-md fade-up">
          <Link to="/" title="Open homepage" className="inline-block lg:hidden mb-6" data-testid="login-mobile-logo-home-link">
            <img src="/images/gamls-logo.png" alt="GAMLS" className="w-20 h-20" />
          </Link>
          {children}
          <Link to="/" className="inline-block mt-6 text-sm font-semibold text-[#E60000] hover:underline" data-testid="login-back-home-link">← Back to events homepage</Link>
        </div>
      </div>
    </div>
    <SiteFooter />
  </div>
);

export const AuthField = ({ label, children }) => (
  <label className="block"><span className="text-xs font-bold uppercase tracking-wider text-gray-600">{label}</span><div className="mt-1.5">{children}</div></label>
);

export const SubmitButton = ({ busy, children, testId }) => (
  <button type="submit" disabled={busy} className="w-full h-11 rounded-md bg-[#E60000] hover:bg-[#CC0000] disabled:opacity-60 text-white font-semibold inline-flex items-center justify-center gap-2 transition-colors" data-testid={testId}>
    {children}
  </button>
);
